import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'

export default class TNomenclatureDM extends Data {
	public static className = 'TNomenclatureDM'
	public static primaryKey = 'Id'
	public static systemFields = [
	]

	public getPrimaryKey(): PrimaryKey {
		return this.Id!
	}

	ExciseTaxId?: number
	Description?: string
	Abbr?: string
	Id?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
}